import styled from 'styled-components'
import { gridItem } from 'styles/mixins'

import { Props } from './props'

export const Wrapper = styled.div<Props>`
  ${gridItem}
`
